module.exports = __webpack_public_path__ + "img/panel_back_inner_frame.da44ea26.png";